import React, { useState } from "react";
import {
  Stack,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
} from "@mui/material";

import AppModal from "../common/AppModal";
import AppButton from "../buttons/AppButton";

import { useAppDispatch, useAppSelector } from "../../redux/store";
import { confirmPurchaseOrder } from "../../redux/actions/purchaseOrderActions";

import { PurchaseOrderResponseDto } from "../../shared/dtos/purchaseOrder/PurchaseOrderResponseDto";
import FormDateField from "../common/FormDateField";
import FormAlert from "../common/FormAlert";

const ConfirmPoModal: React.FC<{
  open: boolean;
  onClose: () => void;
  order: PurchaseOrderResponseDto;
}> = ({ open, onClose, order }) => {
  const dispatch = useAppDispatch();
  const { loadingConfirm, errorConfirm } = useAppSelector(
    (state) => state.purchaseOrder,
  );
  const [expectedDate, setExpectedDate] = useState("");
  const [items, setItems] = useState(
    order.items.map((i) => ({
      itemId: i.id,
      quantity: i.orderedQuantity,
      status: i.status,
      name: i.productName,
    })),
  );

  const handleConfirm = (): void => {
    dispatch(
      confirmPurchaseOrder(order.id, {
        expectedDate: expectedDate
          ? new Date(expectedDate).toISOString()
          : undefined,
        itemUpdates: items.map((i) => ({
          itemId: i.itemId,
          quantity: Number(i.quantity),
          status: i.status,
        })),
      }),
    );
  };

  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Confirm Order ${order.poNumber}`}
      width="md"
      loading={loadingConfirm}
    >
      <FormAlert message={errorConfirm} severity="error" />

      <Stack spacing={3}>
        <FormDateField
          label="Expected Delivery Date"
          value={expectedDate}
          onChange={(value) => setExpectedDate(value)}
        />
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>Approved Qty</TableCell>
              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items.map((item, idx) => (
              <TableRow key={item.itemId}>
                <TableCell>{item.name}</TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    type="number"
                    value={item.quantity}
                    onChange={(e) => {
                      const arr = [...items];
                      arr[idx].quantity = Number(e.target.value);
                      setItems(arr);
                    }}
                  />
                </TableCell>
                <TableCell>
                  <Select
                    size="small"
                    value={item.status}
                    onChange={(e) => {
                      const arr = [...items];
                      arr[idx].status = e.target.value;
                      setItems(arr);
                    }}
                  >
                    <MenuItem value="EXPECTED">Approved</MenuItem>
                    <MenuItem value="CANCELLED">Cancel Item</MenuItem>
                  </Select>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <AppButton
          variant="contained"
          onClick={handleConfirm}
          isLoading={loadingConfirm}
          loadingText="Submitting"
          disabled={!expectedDate || loadingConfirm}
        >
          Submit Confirmation
        </AppButton>
      </Stack>
    </AppModal>
  );
};

export default ConfirmPoModal;
